import { ArrowLeft } from 'lucide-react';

export function BackButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="group inline-flex items-center gap-2 rounded-sm border border-zeb-muted bg-white px-4 py-2.5 text-sm text-zeb-gray-700 transition-[background-color,box-shadow,color] hover:bg-zeb-surface hover:text-zeb-tertiary hover:shadow-zeb-xs active:scale-[0.98] motion-reduce:transform-none motion-reduce:transition-none">
      <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5 motion-reduce:group-hover:translate-x-0" />
      Zurück
    </button>
  );
}
